import React from 'react';
import { motion } from 'framer-motion';
const flow = ['1 → Start visualizing the routine', '2 → Organize activities', '3 → Follow each moment', '4 → Mark what is done', '5 ✓ See the day’s progress'];
const steps = [{
  n: '1',
  title: 'Choose',
  desc: 'Select the activities that make up the day. The system does not try to fill the day with tasks — it only makes visible what comes next.'
}, {
  n: '2',
  title: 'Organize',
  desc: 'Place each activity in morning, afternoon or night. Instead of presenting the whole day at once, every step appears as a small piece of a sequence.'
}, {
  n: '3',
  title: 'Check',
  desc: 'Each activity can be marked when completed, so your child sees progress happening and starts moving through the routine without being asked.'
}];
export function Steps() {
  return <section aria-label="How it works" className="bg-transparent" data-id="element-149" data-mp="2600t1d340gcn">
      <div className="mx-auto max-w-4xl px-5 py-12" style={{
      paddingTop: "12px",
      paddingBottom: "17px"
    }} data-id="element-150" data-mp="2a2x3ggihx65i">
        <p className="text-center text-xs font-bold uppercase tracking-[0.25em] text-grape" data-id="element-151" data-mp="1q9j0aemdo6z2">
          Step by step
        </p>
        <h2 className="mt-3 text-center font-display text-2xl font-black text-plum sm:text-3xl" data-id="element-152" data-mp="2015iww11p8bu">
          From “what do I do now?” to seeing what comes next
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-center text-sm text-plum/60" data-id="element-153" data-mp="1v2u8aj2xetsk">
          A visual routine turns daily activities into a sequence that can be seen, followed and
          checked off, one thing at a time.
        </p>

        <ol className="mt-8 flex flex-wrap justify-center gap-2" data-id="element-154" data-mp="1hanq6rg7qcqh">
          {flow.map(item => <li key={item} className="rounded-full border border-blush/30 bg-blush-soft px-3.5 py-1.5 text-xs font-bold text-blush-deep" data-id="element-155" data-mp="1cbkptkb6guou">
              {item}
            </li>)}
        </ol>

        <ol className="mt-10 space-y-4" data-id="element-156" data-mp="2npy6a43lq7uu">
          {steps.map((s, i) => <motion.li key={s.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-start gap-4 rounded-2xl border border-grape/15 bg-white p-5" data-id="element-157" data-mp="2uu6btvp1x11a" data-mpi={i}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-grape font-display text-base font-black text-white" data-id="element-158" data-mp="39p446ok79qid">
                {s.n}
              </span>
              <div data-id="element-159" data-mp="2h0f3gqn23n75">
                <h3 className="text-base font-bold text-plum" data-id="element-160" data-mp="2m1mcet0xqsfe">{s.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-plum/65" data-id="element-161" data-mp="2lzjb3cuc1cvd">{s.desc}</p>
              </div>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}